module.exports = __webpack_public_path__ + "static/img/glxt_04.5e11e992.png";